export default __webpack_public_path__ + "static/media/arrow-right.a0bb9b05.svg";